<template>
  <div>
    <div class="tableData">
      <span>个险订单共有<span class="num">{{ total }}笔</span></span>
      <div class="table-box setTable">
        <loading :isShow="$root.$children[0].isShowLoading" />
        <Table :columns="columns" :data="tableDate">
          <template slot-scope="{ row }" slot="bar">
            <span @click="showDetail(row)" class="table-btn">详情</span>
            <span
              v-show="$units.pointAction('order_10_3') && row.status == 1 && row.checkInsuranceStatus == 1 && row.payUrl"
              @click="getPayLink(row.payUrl)" class="table-btn">
              获取支付链接
            </span>
            <span class="table-btn" @click="jumpManualUrl(row)"
              v-if="$units.pointAction('order_10_4') && row.checkInsuranceStatus == 2">人核进度</span>

            <Tooltip content="有关联保单的订单不允许删除" style="display:inline-block;" v-if="row.policyNo" transfer>
              <span class="table-btn gray">删除</span>
            </Tooltip>
            <span @click="del(row)" class="table-btn red" v-else>删除</span>
          </template>
        </Table>
      </div>
      <div class="pageBox">
        <Page :total="total" :current="pageNo" :page-size="pageSize" show-total
          @on-change="pageChange" style="text-align: center" />
      </div>
      <!-- 订单详情  -->
    <Modal v-model="showOrderdetail" title="订单详情" :footer-hide="true" width="1100" class="my-modal top">
      <Tabs v-model="type" :animated="false" style="padding-top: 10px">
        <TabPane label="投保信息" name="1">
          <my-form :formList="insurebase" :span="8" class="detail"></my-form>
        </TabPane>
        <TabPane label="被保险人及保障权益" name="2">
          <interests :obj="detailInfo" />
        </TabPane>
      </Tabs>
    </Modal>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
    </div>
  </div>
</template>

<script>
import { config } from './order.config.js';
import { pageTool } from "@/api/mixins";
import insurebase from "./insurebase.js";
import myForm from "@/components/commons/form";
import interests from "./interests";
import confirmModal from '@/components/commons/confirmModal'
import {
  getOrdeDetail,
} from "@/api/httpList";
export default {
  mixins: [pageTool, config],
  components: {
    myForm,
    interests,
    confirmModal
  },
  data(){
    return{
      total: 0,
      pageNo: 1,
      pageSize: 5,
      type: "1",
      columns: [],
      tableDate: [],
      detailInfo: {},
      insurebase: [],
      showOrderdetail: false,
    }
  },
  methods:{
    del(item) {
      this.$refs.confirmModal.open({
        title: "提示",
        content: "确定删除订单？",
      }).then(() => {
        this.$http({
          url: "/buz/order/order/del",
          type: "GET",
          data: {
            id: item.id
          }
        }).then(res => {
          this.$notice.msg('删除订单成功');
          this.getOrder();
        });
      })
    },
    async showDetail(row) {
      this.$notice.showLoading();
      let res = {};
      try {
        res = await getOrdeDetail(row.orderNo);
      } catch (error) {
        console.log(error)
        return;
      } finally {
        this.$notice.hideLoading();
      }
      this.showOrderdetail = true;
      this.type = '1';

      const obj = {
        orgName: row.orgName,
        groupName: row.groupName,
        salesmanName: row.salesmanName,
      };
      this.detailInfo = Object.assign(res.data, obj);
      //回填基本信息
      this.insurebase = insurebase(this, row.status, this.detailInfo, row);
      this.insurebase[0].data.forEach((item) => {
        for (let key in res.data) {
          if (item.key == key) {
            item.value = res.data[key];
          }
          if (!item.value) {
            item.value = "-";
          }
        }
      });
      //投保人信息
      this.insurebase[1].data.forEach((item) => {
        for (let key in res.data.holder) {
          if (item.key == key) {
            item.value = res.data.holder[key];
          }
        }
      });
    },
    // 跳转人核页面
    jumpManualUrl(row) {
      this.$http({
        url: `/buz/order/getManualUrl`,
        type: "GET",
        data:{
          orderNo: row.orderNo
        }
      }).then(res=>{
        if(!res.data) {
          this.$notice.error('人核链接不存在');
          return;
        }
        window.open(res.data);
      })
    },
    getPayLink(payUrl) {
      this.$units.copyUrl(payUrl, false, false);
      this.$Message.success({background: true,
        content:"订单支付链接复制成功，请在移动端打开支付"});
    },
    pageChange(pageNo) {
      this.pageNo = pageNo;
      this.getOrder();
    },
    //搜索
    searchAjax() {
      this.pageNo = 1;
      this.$root.$children[0].isShowLoading = true;
      this.getOrder();
    },
    //获取订单
    async getOrder() {
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: "/buz/order/unpaidList",
        type: "POST",
        data: {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          status:'1',
          checkInsuranceStatusList:["1","10","0"]
        }
      }).then((res) => {
        this.tableDate = res.data;
        this.total = res.total;
        this.$root.$children[0].isShowLoading = false;
      })
        .catch(() => {
          this.$root.$children[0].isShowLoading = false;
        });
    },
  },
  mounted(){
    this.getOrder()
  }
}
</script>

<style lang="scss" scoped>
.tableData{
  padding: 15px 20px 1px 20px;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 18px;
  color: #727C8E;
  .num{
    color: #FF5F00;
  }
  .table-box{
    margin-top: 10px;
  }
}
.table-btn{
  border-right: 1px solid #CED1D5;
  margin: 0;
  padding: 0 6px;
  line-height: 13px;
  &:last-child{
    border:0;
  }
}
</style>